import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PropTypes } from 'prop-types';
import { makeStyles, TableCell, TableRow } from '@material-ui/core';
import classNames from 'classnames';
import { useMeContext } from '~/modules/me';
import UserDefinedSkillRow from './UserDefinedSkillRow';
import { useStyles as useHeaderStyles } from './UserDefinedSkillList';

const useStyles = makeStyles(theme => ({
  headerCell: {
    border: 'none',
    padding: theme.spacing(1, 0, 0, 0)
  },
  root: {
    paddingLeft: theme.spacing(0.5)
  },
  lastRow: {
    borderBottom: `1px solid ${theme.palette.table.border}`
  }
}));

export const EditableUserDefinedSkills = ({
  userDefinedSkills,
  maxSkillLevel,
  onUserDefinedSkillRemove,
  onUserDefinedSkillRatingUpdate,
  skillSettings
}) => {
  const classes = useStyles();
  const headerClasses = useHeaderStyles();
  const {
    featureFlags: { isPsaPraaUserProfileNudgesEnabled }
  } = useMeContext();

  if (
    (userDefinedSkills || []).length === 0 ||
    !isPsaPraaUserProfileNudgesEnabled
  )
    return null;

  return (
    <>
      <TableRow>
        <TableCell colSpan={3} className={classes.headerCell}>
          <div className={classNames(headerClasses.title, classes.root)}>
            <FormattedMessage id="skillInfoCard.userDefinedSkills" />
          </div>
          <div className={classNames(headerClasses.description, classes.root)}>
            <FormattedMessage id="skillInfoCard.skillsDescription" />
          </div>
        </TableCell>
      </TableRow>
      {userDefinedSkills.map((userDefinedSkill, index) => (
        <UserDefinedSkillRow
          className={
            index === userDefinedSkills.length - 1 ? classes.lastRow : ''
          }
          key={userDefinedSkill.displayText}
          userDefinedSkill={userDefinedSkill}
          maxSkillLevel={maxSkillLevel}
          onUserDefinedSkillRemove={onUserDefinedSkillRemove}
          skillsettings={skillSettings}
          onUserDefinedSkillRatingUpdate={onUserDefinedSkillRatingUpdate}
        />
      ))}
    </>
  );
};

EditableUserDefinedSkills.propTypes = {
  userDefinedSkills: PropTypes.array,
  maxSkillLevel: PropTypes.number,
  onUserDefinedSkillRemove: PropTypes.func.isRequired,
  onUserDefinedSkillRatingUpdate: PropTypes.func.isRequired,
  skillSettings: PropTypes.array
};

export default EditableUserDefinedSkills;
